import { Field } from 'components/Wizards/Field/Field'
import { Select } from 'components/Select/Select'
import { Item } from '@react-stately/collections'

type Props = {
  ageRange?: string
  onUpdate: (ageRange: string) => void
}

const RepresentationAge = ({ ageRange, onUpdate }: Props) => {
  return (
    <Field label="Age" labelType="label" data-testid="representation-age">
      <Select
        aria-label="Representation age range"
        variant="secondary"
        selectedKey={ageRange || 'all'}
        onSelectionChange={(key) => onUpdate(key as string)}
        placeholder="Select age range"
        size="lg"
        useFullWidth
      >
        <Item key="all">All</Item>
        <Item key="18-24">18-24</Item>
        <Item key="25-34">25-34</Item>
        <Item key="35-44">35-44</Item>
        <Item key="45-54">45-54</Item>
        <Item key="55-64">55-64</Item>
        <Item key="65+">65+</Item>
      </Select>
    </Field>
  )
}

export { RepresentationAge }
